<template>
  <div>
    <div>
      <div class="fxd .f b b-cl">
        <SummaryWidget v-if="$route.query.widget.toLowerCase() == 'summary'" :class="styles[$route.query.style || 'card'] + ' b-fg' + ' p-b-4'" :embed="true"></SummaryWidget>
        <ListWidget    v-else-if="$route.query.widget.toLowerCase() == 'list'" :class="styles[$route.query.style || 'card'] + ' b-fg'" :embed="true"></ListWidget>
        <DetailsWidget v-else-if="$route.query.widget.toLowerCase() == 'details'" :class="styles[$route.query.style || 'card'] + ' b-fg'" :embed="true"></DetailsWidget>
        <ChartWidget   v-else-if="$route.query.widget.toLowerCase() == 'chart'" :class="styles[$route.query.style || 'card'] + ' b-fg'" :embed="true"></ChartWidget>
        <PostsWidget   v-else-if="$route.query.widget.toLowerCase() == 'posts'" :class="styles[$route.query.style || 'card'] + ' b-fg'" :embed="true"></PostsWidget>
        <div v-else="" :class="styles[$route.query.style || 'card'] + ' b-cl b-fg'">
            <SummaryWidget></SummaryWidget>
            <ListWidget class="h-15 -o-a b-fg" style="margin-top: -170px;padding-top: 170px;min-height: 600px;-webkit-mask-image: linear-gradient(transparent, rgb(0, 0, 0) 40%);"></ListWidget>
            <div class="fxd .f > -o-y-a -z-2" :class="countryPanelOpen?'':'slide-on-mobile-f'">
              <div class="abs .f c20"></div>
              <div  class="h-10 b b-a-c b-j-sb rlt e-4 -z-1">
                <div class="b b-c">
                  <div class="unt btn-n u-8 m-x-4 c0-t">
                    <i class="material-icons">bar_chart</i>
                  </div>{{ $t('data_of') }}  <span v-if="country" class="m-s-3"> {{ country.name }} </span>
                </div>
                <div class="b">
                  <div class="unt btn-n u-8 m-x-4" @click="countryPanelOpen=false">
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </div>
              <DetailsWidget style="--el-u:0; --el-p:0;" class="l20 d1 -o-h -r-m rlt e-1 l:m-b-6"></DetailsWidget>
              <ChartWidget class="l20 d1 -o-h -r-m p-5 rlt e-1 l:m-b-6" ></ChartWidget>
              <PostsWidget class="e-1 l20 d1 -o-h -r-m" ></PostsWidget>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
// Widgets
import SummaryWidget from '../widgets/Summary'
import ListWidget from '../widgets/List'
import DetailsWidget from '../widgets/Details'
import ChartWidget from '../widgets/Chart'
import PostsWidget from '../widgets/Posts'

export default {
  name: 'Home',
  components: {
    SummaryWidget,
    ListWidget,
    DetailsWidget,
    ChartWidget,
    PostsWidget
  },
  computed: {
    ...mapState(['countries', 'countriesData', 'selectedCountry']),
    ...mapGetters(['getSelectedCountries', 'isMedia'])
  },
  data () {
    return {
      countryPanelOpen: 0,
      selectedWidget: ['list'],
      styles: {
        card: 'e-1 l20 d1 -r-m'
      },
      wedgets: {
        list: {
          summary: SummaryWidget,
          list: ListWidget,
          details: DetailsWidget,
          chart: ChartWidget,
          posts: PostsWidget,
          default: 'default'
        }
      }
    }
  },
  watch: {
    selectedCountry (newValue, oldValue) {
      this.countryPanelOpen = 1
    }
  }
}
</script>
<style lang="scss" scoped>
  .slide-on-mobile-f {
    transform: translateY(100%)
  }
</style>
